import {Component, inject, input} from '@angular/core';
import {
	NotificationCenterComponent
} from '../../../../../shared/components/notification-center/notification-center.component';
import {Divider} from 'primeng/divider';
import {SidebarCurrentUser} from '../sidebar-current-user/sidebar-current-user';
import {ToggleSwitch, ToggleSwitchChangeEvent} from 'primeng/toggleswitch';
import {FormsModule} from '@angular/forms';
import {NgClass} from '@angular/common';
import {SettingsStore} from '../../../../store/settings.store';

@Component({
	selector: 'app-sidebar-actions',
	imports: [
		NotificationCenterComponent,
		Divider,
		SidebarCurrentUser,
		ToggleSwitch,
		FormsModule,
		NgClass
	],
	standalone: true,
	host: {
		'class': 'sidebar-actions',
		'[class.sidebar-actions--expanded]': 'expanded()'
	},
	template: `
		<app-notification-center></app-notification-center>
		<p-toggleswitch [(ngModel)]="checked" (onChange)="toggleDarkMode($event)">
			<ng-template #handle let-checked="checked" class="p-2">
				<i [ngClass]="['pi', checked ? 'pi-moon' : 'pi-sun']"></i>
			</ng-template>
		</p-toggleswitch>
		<p-divider class="m-0" [layout]="expanded() ? 'vertical' : 'horizontal'"></p-divider>
		<app-sidebar-current-user></app-sidebar-current-user>
	`,
	styleUrl: './sidebar-actions.css'
})
export class SidebarActions {
	private settingStore: SettingsStore = inject(SettingsStore);

	expanded = input(false)
	checked = this.settingStore.darkTheme

	toggleDarkMode(e: ToggleSwitchChangeEvent) { this.settingStore.setDarkTheme(e.checked) }
}
